import TrackedLink from "./TrackedLink";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ProgressiveImage from "./ProgressiveImage";

export default function ContractorCard({
  href,
  profileId,
  trackingEvent,
  cardNo,
  coverImage,
  coverImageAlt = "Site photos",
  photosCount,
  businessName,
  businessLogo,
  contractorName,
  contractorImage,
  location,
  workExpYears,
  projectsCount,
  labourCost,
}) {
  const isBusiness = Boolean(businessName);
  const displayName = isBusiness ? businessName : contractorName;
  const avatarImage = isBusiness ? businessLogo : contractorImage;
  const avatarInitial = displayName?.charAt(0)?.toUpperCase();

  const Wrapper = href ? TrackedLink : "div";
  const wrapperProps = href
    ? { href, event: trackingEvent, properties: { event_value: profileId, contractor_name: displayName, ...(cardNo != null && { card_no: cardNo }) } }
    : {};

  const stats = [];
  if (workExpYears != null) {
    stats.push({ label: "Work Exp.", value: `${workExpYears} ${Number(workExpYears) > 1 ? "Yrs" : "Yr"}` });
  }
  if (projectsCount != null) stats.push({ label: "Projects", value: `${projectsCount}+` });
  if (labourCost) stats.push({ label: "Labour Cost*", value: labourCost });

  return (
    <Wrapper
      {...wrapperProps}
      className="flex w-full flex-col overflow-hidden rounded-[--radius8] border border-[--colorDisabledOnColorDisabled] bg-[--colorSurfaceSurface] shadow-[0px_1px_3px_1px_#0000001A,0px_1px_2px_0px_#0000001A]"
    >
      <div className="relative aspect-[343/160] w-full flex-shrink-0 bg-[--colorSurfaceSurfaceVar]">
        {coverImage && (
          <ProgressiveImage
            src={coverImage}
            alt={coverImageAlt}
            className="object-cover"
            sizes="(max-width: 640px) 100vw, 400px"
          />
        )}

        {photosCount != null && (
          <div className="absolute right-4 bottom-4 flex items-center gap-1 rounded-full bg-[--colorSurfaceSurface] px-2 py-1">
            <ImageOutlinedIcon sx={{ fontSize: 16 }} className="text-[--textPrimaryPrimary]" />
            <span className="m3-label-medium text-[--textPrimaryPrimary]">
              {Number(photosCount).toLocaleString("en-IN")}
            </span>
          </div>
        )}

        <div
          className={`absolute -bottom-2 left-4 h-16 w-16 overflow-hidden border-[3px] border-[--colorSurfaceSurface] bg-[--colorSurfaceSurfaceVar] ${
            isBusiness ? "rounded-[--radius16]" : "rounded-full"
          }`}
        >
          {avatarImage ? (
            <ProgressiveImage src={avatarImage} alt={displayName || "Avatar"} className="object-cover" sizes="64px" />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-[--colorSuccessSuccess]">
              <span className="m3-title-medium text-[--textPrimaryOnColorPrimary]">{avatarInitial}</span>
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-[1fr_auto_auto_auto] items-baseline gap-x-3 px-4 py-3">
        <h3
          className="m3-label-large truncate text-[--textPrimaryPrimary]"
          style={{ gridColumn: 1, gridRow: 1 }}
        >
          {displayName}
        </h3>
        <p
          className="m3-body-small truncate text-[--textSecondarySecondary]"
          style={{ gridColumn: 1, gridRow: 2 }}
        >
          {location}
        </p>

        {stats.map((stat, i) => (
          <dl key={stat.label} className="contents">
            <dt
              className="m3-body-small whitespace-nowrap text-[--textSecondaryOnColorSecondary]"
              style={{ gridColumn: i + 2, gridRow: 2 }}
            >
              {stat.label}
            </dt>
            <dd
              className="m3-title-medium whitespace-nowrap text-[--textPrimaryPrimary]"
              style={{ gridColumn: i + 2, gridRow: 1 }}
            >
              {stat.value}
            </dd>
          </dl>
        ))}
      </div>
    </Wrapper>
  );
}
